export const FooterMenu = [
  {
    items: [
      {
        label: 'Actualités',
        url: 'https://fr.benzinga.com/actualites/',
      },
      {
        label: 'Monde',
        url: 'https://fr.benzinga.com/actualites/autres-marches/',
      },
      {
        label: 'Actualités USA',
        url: 'https://fr.benzinga.com/seance-de-marche-usa/',
      },
      {
        label: 'Trading',
        url: 'https://fr.benzinga.com/news/usa/trading/',
      },
      {
        label: 'Cryptomonnaies',
        url: 'https://fr.benzinga.com/cryptomonnaies/',
      },
    ],
    label: 'Notizie',
  },
  {
    items: [
      {
        label: 'Licences et syndication',
        url: 'https://fr.benzinga.com/nous-contacter/',
      },
      {
        label: 'Contenu sponsorisé',
        url: 'https://fr.benzinga.com/nous-contacter/',
      },
      {
        label: 'Publier une annonce',
        url: 'https://fr.benzinga.com/nous-contacter/',
      },
      {
        label: 'Demander un kit média',
        url: 'https://fr.benzinga.com/nous-contacter/',
      },
      {
        label: 'À propos de nous',
        url: 'https://fr.benzinga.com/a-propos-de-nous/',
      },
    ],
    label: 'PARTENAIRE / CONTRIBUTEUR',
  },
  {
    items: [
      {
        label: 'Benzinga États-Unis',
        url: 'https://www.benzinga.com/',
      },
      {
        label: 'Benzinga Corée',
        url: 'https://kr.benzinga.com/',
      },
      {
        label: 'Benzinga Japon',
        url: 'https://jp.benzinga.com/',
      },
      {
        label: 'Benzinga Italie',
        url: 'https://it.benzinga.com/',
      },
      {
        label: 'Benzinga Espagne',
        url: 'https://es.benzinga.com/',
      },
      {
        label: 'Benzinga Inde',
        url: 'https://in.benzinga.com//',
      },
    ],
    label: 'BENZINGA MONDIAL',
  },
];

export const FooterCopyRightLinks = [
  {
    label: 'Mentions légales',
    url: 'https://fr.benzinga.com/mentions-legales/',
  },
  {
    label: 'Confidentialité',
    url: 'https://fr.benzinga.com/confidentialite/',
  },
  {
    label: 'Accessibility',
    url: '#',
  },
];
